import React, { useEffect, useState } from 'react';
import api from '../../lib/api';

/**
 * FeatureInventory — list of every "feature" memory entry. The Lab AI
 * uses these as the canonical feature list when answering "what does
 * ATDE do?" questions.
 */
export default function FeatureInventory() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get('/lab/inventory').then(({ data }) => setData(data)).catch(() => {});
  }, []);

  if (!data) return <div className="p-4 text-[11px] text-[var(--txt-secondary)]">loading…</div>;

  return (
    <div data-testid="lab-inventory" className="space-y-2">
      <div className="text-[10px] tracking-[0.25em] uppercase text-[var(--txt-secondary)]">
        {data.count} features indexed
      </div>
      {(data.features || []).map((f) => (
        <div key={f.id} data-testid={`lab-feature-${f.id}`} className="border border-[var(--border-default)] p-3">
          <div className="text-[12px] text-cyan-sys">{f.title}</div>
          {f.body && <div className="text-[11px] text-[var(--txt-secondary)] mt-1 whitespace-pre-line">{f.body}</div>}
          {(f.files?.length) ? (
            <div className="mt-2 flex flex-wrap gap-1 text-[9px] font-mono text-cyan-sys">
              {f.files.map((file) => <span key={file}>· {file}</span>)}
            </div>
          ) : null}
        </div>
      ))}
    </div>
  );
}
